import React, { useState, useEffect, useCallback } from 'react';
import styles from './HeroSlideshow.module.css';

// Add or remove entries here; missing images are skipped automatically
const ALL_SLIDES = [
  { src: '/hero/slide1.jpg',  alt: 'CNC Machines' },
  { src: '/hero/slide2.jpg',  alt: 'Industrial Machinery' },
  { src: '/hero/slide3.jpg',  alt: 'Heavy Equipment' },
  { src: '/hero/slide4.jpg',  alt: 'Lathe Machines' },
  { src: '/hero/slide5.jpg',  alt: 'Workshop Equipment' },
  { src: '/hero/slide6.jpg',  alt: 'Milling Machines' },
  { src: '/hero/slide7.jpg',  alt: 'Grinding Machines' },
  { src: '/hero/slide8.jpg',  alt: 'Drilling Machines' },
  { src: '/hero/slide9.jpg',  alt: 'Pressing Machines' },
  { src: '/hero/slide10.jpg', alt: 'Turning Machines' },
  { src: '/hero/slide11.jpg', alt: 'Boring Machines' },
  { src: '/hero/slide12.jpg', alt: 'Welding Equipment' },
  { src: '/hero/slide13.jpg', alt: 'Hydraulic Machines' },
  { src: '/hero/slide14.jpg', alt: 'Fabrication Equipment' },
  { src: '/hero/slide15.jpg', alt: 'Industrial Equipment' },
];

export default function HeroSlideshow() {
  const [slides, setSlides]           = useState(ALL_SLIDES);
  const [current, setCurrent]         = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  // Remove a slide if its image 404s
  const handleError = useCallback((failedSrc) => {
    setSlides(prev => {
      const next = prev.filter(s => s.src !== failedSrc);
      return next.length ? next : prev; // keep at least one
    });
    setCurrent(0);
  }, []);

  const goTo = useCallback((index) => {
    if (transitioning) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 400);
  }, [transitioning]);

  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [slides.length]);

  const prev = () => goTo((current - 1 + slides.length) % slides.length);
  const next = () => goTo((current + 1) % slides.length);

  return (
    <div className={styles.slideshow}>
      {slides.map((slide, i) => (
        <div
          key={slide.src}
          className={`${styles.slide} ${i === current ? styles.active : ''} ${transitioning && i === current ? styles.transitioning : ''}`}
        >
          <img
            src={slide.src}
            alt={slide.alt}
            className={styles.img}
            onError={() => handleError(slide.src)}
          />
          <div className={styles.fallback} />
        </div>
      ))}

      <div className={styles.overlay} />
      <div className={styles.stripe} />

      <button className={`${styles.arrow} ${styles.arrowLeft}`} onClick={prev} aria-label="Previous">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <button className={`${styles.arrow} ${styles.arrowRight}`} onClick={next} aria-label="Next">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </button>

      <div className={styles.dots}>
        {slides.map((_, i) => (
          <button
            key={i}
            className={`${styles.dot} ${i === current ? styles.dotActive : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
